import React, { useState } from 'react';
import { useLang } from '../hooks/useLang';
import Impressum from './Impressum';
import AGBDatenschutz from './AGBDatenschutz';
import FAQ from './FAQ';

const FooterRedesign = ({ onShowAboutUs }) => {
  const { lang } = useLang();
  const [showImpressum, setShowImpressum] = useState(false);
  const [showAGBDatenschutz, setShowAGBDatenschutz] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  return (
    <footer className="bg-gray-900 text-gray-400 py-12 mt-20">
      <div className="container mx-auto px-6 text-center">
        {/* Logo */}
        <div className="mb-8">
          <img src="/CENTEO-C.png" alt="CENTEO" className="h-8 mx-auto opacity-80" />
        </div>
        
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-8 mb-8">
          <button
            onClick={onShowAboutUs}
            className="text-sm hover:text-green-400 transition-colors duration-200"
          >
            {lang === 'de' ? 'Über Uns' : lang === 'es' ? 'Sobre Nosotros' : lang === 'it' ? 'Chi Siamo' : lang === 'pt' ? 'Sobre Nós' : 'About Us'}
          </button>
          <button
            onClick={() => setShowFAQ(true)}
            className="text-sm hover:text-green-400 transition-colors duration-200"
          >
            {lang === 'de' ? 'FAQ' : lang === 'es' ? 'Preguntas Frecuentes' : lang === 'it' ? 'Domande Frequenti' : lang === 'pt' ? 'Perguntas Frequentes' : 'FAQ'}
          </button>
          <button
            onClick={() => setShowImpressum(true)}
            className="text-sm hover:text-green-400 transition-colors duration-200"
          >
            Impressum
          </button>
          <button
            onClick={() => setShowAGBDatenschutz(true)}
            className="text-sm hover:text-green-400 transition-colors duration-200"
          >
            {lang === 'en' ? 'Terms & Privacy' : lang === 'es' ? 'Términos y Privacidad' : lang === 'it' ? 'Termini & Privacy' : lang === 'pt' ? 'Termos & Privacidade' : 'AGB & Datenschutz'}
          </button>
        </div>
        
        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          <p className="text-sm">
            © 2024 CENTEO. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Professionelle Förderberatung für die Landwirtschaft.
          </p>
        </div>
      </div>

      {/* Modals */}
      {showFAQ && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-6xl w-full h-full sm:h-auto sm:max-h-[95vh] overflow-y-auto relative">
            <button
              onClick={() => setShowFAQ(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold z-10"
            >
              ×
            </button>
            <FAQ />
          </div>
        </div>
      )}
      {showImpressum && (
        <Impressum onClose={() => setShowImpressum(false)} />
      )}
      {showAGBDatenschutz && (
        <AGBDatenschutz onClose={() => setShowAGBDatenschutz(false)} />
      )}
    </footer>
  );
};

export default FooterRedesign;
